export const MASK_OF_PHONE = '+# (###)-###-##-##'
export const MASK_OF_PHONE_OR_EMAIL = '+*0 *0*0*0-*0*0*0-*0*0-*0*0'
export const MASK_OF_DATE = '##.##.####'
export const MASK_OF_TIME = '##:##'
